import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { TransferMaterialInfo } from './all-transfer-material-info'
export class AllTransferInfo extends GlobalResponseObject {
    data?: TransferMaterialInfo[] | TransferMaterialInfo;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: TransferMaterialInfo[] | TransferMaterialInfo) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}